import styled from 'styled-components';
import theme, { rems } from 'fe-appdir-lib-theme';

const AppCardCategory = styled.p`
  margin: 6px 0 0;
  font-size: ${(props) => (props.large ? rems(12) : rems(10))};
  font-weight: 400;
  text-transform: lowercase;
  color: ${theme.colorGrey20};
  letter-spacing: 0.02em;
`;

AppCardCategory.displayName = 'AppCardCategory';

export { AppCardCategory };
